import React from "react";
import membersBackground from "../images/membersBackground.webp";
import BulletPoints from "./bullet-points";

export const Members = () => {
  return (
    <section className="members-section" style={{ backgroundImage: `url(${membersBackground})` }}>
      <div className="members-content">
        <h2 className="members-title">Who is on Radivision?</h2>
        <div className="members-circles">
          <div className="circle">
            <p>Startup Enthusiasts</p>
          </div>
          <div className="circle">
            <p>Startup Founders</p>
          </div>
          <div className="circle">
            <p>Investors</p>
          </div>
          <div className="circle">
            <p>Ecosystem Partners</p>
          </div>
        </div>
        <BulletPoints />
        <button className="members-join-button">Join</button>
      </div>
    </section>
  );
};
